import { Timestamp } from 'firebase/firestore';

import {
  EStatus,
  type IMetadata,
  type IObjectId,
  type TDuration,
} from './common.type';
import {
  CNsDuration,
  type CNsPrice,
  CNsTrial,
  DEFAULT_PRICE_VALUES,
  ECurrency,
  type IPrice,
} from './price.type';

export const CFeaturesPath = 'features';

export const CFeatureSlugMaxLength = 50;
export const CFeatureSlugPattern = /^[a-z][a-z0-9_]{0,49}$/;

export function slugifyFeatureTitle(title: string): string {
  return (title ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, CFeatureSlugMaxLength);
}

export const utilityCounter = 'utilityCounter';

export interface IUtilityCounter {
  counter: number;
  [CNsDuration]: TDuration;
}

const getDefaultFeature = (): Partial<IFeature> => ({
  title: '',
  slug: '',
  description: '',
  tags: [],
  selectedByDefault: false,
  isTrialed: false,
  isPublic: false,
  ...DEFAULT_PRICE_VALUES(ECurrency.USD, false),
  [CNsTrial]: {
    ...DEFAULT_PRICE_VALUES(ECurrency.USD, false, {
      originalPrice: 0,
      [CNsDuration]: {
        type: 'YEAR',
        period: 10,
      },
    }),
    [CNsDuration]: {
      type: 'WEEK',
      period: 10,
    },
  },
  [utilityCounter]: null,
  type: 'BUSINESS',
  status: EStatus.PROCESSING,
  metadata: {
    createdAt: Timestamp.fromDate(new Date()),
    updatedAt: Timestamp.fromDate(new Date()),
  },
});

export enum EFeatureType {
  BUSINESS = 'Business',
  CONSUMER = 'Consumer',
}

export interface IFeature {
  id: IObjectId['id'];
  slug: string;
  title: string;
  description: string;
  tags: string[];
  selectedByDefault: boolean;
  isPublic: boolean;
  metadata: IMetadata;
  [CNsPrice]: IPrice;
  isTrialed: boolean;
  [CNsTrial]: { [CNsPrice]: IPrice; [CNsDuration]: TDuration } | null;
  [utilityCounter]?: IUtilityCounter | null;
  type: keyof typeof EFeatureType;
  status: EStatus;
}

export const DEFAULT_FEATURE = getDefaultFeature;
